import { render, staticRenderFns } from "./CustomerInfoNote.vue?vue&type=template&id=36a5ce2a"
import script from "./CustomerInfoNote.vue?vue&type=script&lang=js"
export * from "./CustomerInfoNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports